module.exports = __webpack_public_path__ + "public/img/Layanan Pelanggan Berbasis Digital.b275f26a.png";